export const getters = {
  envelopeTagsOverlaps: (state) => (envelopeId) => {
    const envelope = state.tagsOverlaps.find(item => item.envelopeId === envelopeId)
    return envelope?.tagIds || null
  },
  pageContentByNumber: state => pageNumber => state.pageContents[pageNumber],
  pageThumbByNumber: state => pageNumber => state.pageThumbs[pageNumber],
}
